import { useState } from "react";
import { useSelector } from "react-redux";

import { getTranslatedTextSelector } from "../../../redux/slices/translatedText/getTranslatedText";

// import ServerUpgradtionModal from "../../ServerUpgradtionModal";

import CourseCompletion from "./CourseCompletion";

import ModuleCompletion from "./ModuleCompletion";

import { useGetCertificate } from "./queries";

const Certificate = () => {
  const [tab, setTab] = useState(1);
  const getTranslateText = useSelector(getTranslatedTextSelector);
  const [showbutton, setShowButton] = useState(false);
  // const [serverErrorModal, setServerErrorModal] = useState(false);
  const userTypeId = localStorage.getItem("userTypeId");

  const {isLoading , data:certificateResponse} = useGetCertificate()

  const {data} = certificateResponse || {};

  const {response} = data || {};

  const {courses , modules} = response || {};

  const tabsList =
    userTypeId === "12"
      ? [
          {
            id: 1,
            title: (
              <>
                {getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item.pageKey === "key_course"
                    )[0]?.keyValue
                  : "Course"}
              </>
            ),
            content: <CourseCompletion />,
          },
        ]
      : [
          {
            id: 1,
            title: (
              <>
                {getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item.pageKey === "key_module"
                    )[0]?.keyValue
                  : "Module"}
              </>
            ),
            // title: "Module",

            content: <ModuleCompletion />,
          },
          {
            id: 2,
            title: (
              <>
                {getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item.pageKey === "key_course"
                    )[0]?.keyValue
                  : "Course"}
              </>
            ),
            content: <CourseCompletion />,
          },
        ];

  // Handle Tab CLick //
 
  const handleTabsClick = (e) => {
    const convertToNumber = Number.parseInt(e.target.id);
    setTab(convertToNumber);
  };

  return (
    <>
      <div className="bg-[#F4F4FA] md:py-[20px] py-[10px] px-[20px] xl:px-[100px] lg:px-[50px] h-[100Vh] h-[calc(100%_-_9%)] overflow-y-scroll no-scrollbar">
        {/* Tabs */}
        <div className="flex flex-row justify-center md:justify-start md:my-[40px] my-[20px]">
          {tabsList?.map((tabs, i) => (
            <button
              key={i}
              id={tabs.id}
              onClick={handleTabsClick}
              className={`${
                tab === tabs.id
                  ? "bg-[#303A70] bg-gradient-to-r from-[#303A70] to-[#121A43] !text-white"
                  : "bg-[#E3E3EF] text-[#10194280]"
              } px-[45px] py-[8px] rounded-[25px] text-[16px] mr-[20px] md:mr-[40px]`}
            >
              {tabs.title}
            </button>
          ))}
        </div>
        <div className="rounded-[30px] md:bg-[#FFFFFF] md:p-[20px] md:h-[calc(100%_-_20%)] no-scrollbar">
          {tabsList?.map((tabs, i) => (
            // <div key={i}>
            <>
              {tab === tabs.id && (
                <>
                      <div>
                        {userTypeId === "12" ? (
                          <CourseCompletion
                            certificateState={courses}
                            shimmer={isLoading}
                            setShowButton={setShowButton}
                          />
                        ) : (
                          (tabs.id === 1 && (
                            <ModuleCompletion
                              certificateState={modules}
                              shimmer={isLoading}
                              setShowButton={setShowButton}
                            />
                          )) ||
                          (tabs.id === 2 && (
                            <CourseCompletion
                              certificateState={courses}
                              shimmer={isLoading}
                              setShowButton={setShowButton}
                            />
                          ))
                        )}
                      </div>
                   
                </>
              )}
              {/* </div> */}
            </>
          ))}
        </div>
      </div>
      {/* <ServerUpgradtionModal
        show={serverErrorModal}
        setShow={setServerErrorModal}
        apiCall={getCourseList}
      /> */}
    </>
  );
};

export default Certificate;
